import { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
export default {
    mainWrapper: {
        display: 'flex',
        position: 'fixed',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        overflow: 'auto',
        minWidth: 0,
        justifyContent: 'center',
        alignItems: 'center',
        p: 6,
    },
};
